import { render, staticRenderFns } from "./OneCharacterInterstitial.vue?vue&type=template&id=5118bf17&scoped=true&"
import script from "./OneCharacterInterstitial.vue?vue&type=script&lang=js&"
export * from "./OneCharacterInterstitial.vue?vue&type=script&lang=js&"
import style0 from "./OneCharacterInterstitial.vue?vue&type=style&index=0&id=5118bf17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118bf17",
  null
  
)

export default component.exports